import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EmdmIcons } from 'src/app/services/appicons.service';
import { commonService } from 'src/app/services/common.service';
import { AcdService } from 'src/app/services/dashboard.service';

@Component({
  selector: 'app-acd-view',
  templateUrl: './acd-view.component.html',
  styleUrl: './acd-view.component.scss'
})
export class AcdViewComponent {

  defineView = false;
  searchView = false;
  buildView = true;
  summaryView = true;

  crNo = 0;
  crStatus = "";
  crDetails: any = null;
  userAccess = true;
  buildType = '';
  stepDetails: any = {
    stepName: '',
    stepNumber: 0
  };

  isUserHaveAccess: boolean | null = null;
  constructor(private route: ActivatedRoute, private router: Router,
    private acdservice: AcdService, public iconPack: EmdmIcons, private commonService: commonService) { }

  ngOnInit() {
    this.route.queryParams.subscribe((param: any) => {
      let updatedCrno = parseInt(param.CR ?? '0');
      
      let newBuildType = param.buildType ?? '';
      if (newBuildType != '' && this.buildType != newBuildType) {
        this.buildType = param.buildType ?? '';
      }

      let newStep = param.step ?? '';
      if (newStep != '' && this.stepDetails.stepName != newStep) {
        this.viewEnable(newStep);
      }

      if (this.crNo != updatedCrno) {
        this.crNo = updatedCrno;
        this.getACDDetails(newStep);
      }
    });
  }

  viewReset() {
    this.defineView = false;
    this.searchView = false;
    this.buildView = false;
    this.summaryView = false;
    this.stepDetails = null;
  }

  viewEnable(step: string) {
    this.viewReset();

    if (step == 'Define') {
      this.defineView = true;
      this.stepDetails = {
        stepName: 'Define',
        stepNumber: 1
      }
    }
    else if (step == 'Search') {
      if (this.isUserHaveAccess == null || this.isUserHaveAccess) {
        this.searchView = true;
        this.stepDetails = {
          stepName: 'Search',
          stepNumber: 2
        };
      }
      else {
        this.accessDeniedNavigation();
      }
    }
    else if (step == 'Build') {
      this.buildView = true;
      this.stepDetails = {
        stepName: 'Build',
        stepNumber: 3
      }
    }
    else if (step == 'Summary') {
      this.summaryView = true;
      this.stepDetails = {
        stepName: 'Summary',
        stepNumber: 4
      }
    }
  }

  accessDeniedNavigation() {
    this.commonService.showNotificationMessage('Changes cannot be made to change requests not created by you or on your behalf.', 'warning', 'center', 200, false);
    this.router.navigate(['ACD', 'ViewRequest'], { queryParams: { CR: this.crNo } });
  }

  getACDDetails(stepName: string = "") {
    this.acdservice.viewAcd(this.crNo).subscribe((data) => {
      if (data) {
        this.crDetails = data;

        let userRoles = JSON.parse(sessionStorage.getItem('userRoles') || '[]');

        userRoles = userRoles.map((x: string) => x.toLocaleLowerCase());

        this.isUserHaveAccess = (userRoles.includes('admin') || userRoles.includes('specialist') || this.crDetails.isUserCanAccessRequest) ?? false;

        if (stepName == "Search" && !this.isUserHaveAccess) {
          this.accessDeniedNavigation();
        }
      }
    });
  }

}
